import { LoginPageContent } from "@app/auth/pages";
import { reverseGuardedRoutes } from "@framework/middleware";
import { pageHead } from "@framework/config/drivers";
import { getLoaderEndpoint } from "@framework/config/drivers/loader";
import { trans } from "@mongez/localization";
import { type LoaderFunctionArgs } from "@remix-run/node";

const guestOnlyLoader = reverseGuardedRoutes();

export async function loader(args: LoaderFunctionArgs) {
  if (!new URL(args.request.url).searchParams.has("suspended")) {
    return guestOnlyLoader(args);
  }

  const { removeUser, success } = await getLoaderEndpoint(
    args.request,
    args.context,
  );

  removeUser();

  return success({});
}

export default function Login() {
  return <LoginPageContent />;
}

export function meta() {
  return pageHead({
    title: trans("auth.login"),
  });
}
